import { render, staticRenderFns } from "./Favourites.vue?vue&type=template&id=284e4ffd&scoped=true"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"
import style0 from "./Favourites.vue?vue&type=style&index=0&id=284e4ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e4ffd",
  null
  
)

export default component.exports